import api from '../../models/services'

export default {
  data() {
    return {
      role_list: [],
      role_id: 99,
      menu_list: [],
    }
  },
  created() {
    this.checkOAuth()
  },
  methods: {
    callback(val) {
      console.log(val)
    },
    getRoleData() {
      api.getRole(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.role_list = result.data
            this.role_id = this.role_list[0].r_id
            this.getMenu(this.role_id)
          } else {
            this.alert_msg('warning', 'Permission', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Permission', error.message)
          this.required = true
        }
      )
    },
    getMenu(roleId) {
      api.getPermission(
        this.$store.state.URLHost,
        roleId,
        this.header,
        (result) => {
          if (result.response === true) {
            this.menu_list = result.data
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          } else {
            this.alert_msg('warning', 'Permission', result.message)
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          }
        },
        (error) => {
          this.alert_msg('error', 'Permission', error.message)
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut()
          this.required = true
        }
      )
    },
    updatePermission(roleId, menuId) {
      // eslint-disable-next-line no-undef
      $('.preloader').fadeIn()
      api.updateMenus(
        this.$store.state.URLHost,
        { role_id: roleId, menu_id: menuId },
        this.header,
        (result) => {
          if (result.response === true) {
            this.alert_msg('success', 'Edit Permission', result.message)
            this.getMenu(roleId)
          } else {
            this.alert_msg('warning', 'Edit Permission', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Edit Permission', error.message)
          this.required = true
        }
      )
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRoleData()
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/permission.js